export const FIELD_NAMES = {
  DATE: 'date',
  TIME: 'time',
  RESULT: 'result',
} as const;
